import { Trans } from 'react-i18next';
import React from 'react';

import { generatePolicyLink, getProjectEmail } from 'helpers/settings';

import { Box, Text } from 'libComponents';

import styles from './FooterWithPolicy.module.css';

import { FooterWithPolicyProps } from './types';

import { LINKS } from './config';

const FooterWithPolicy: React.FC<FooterWithPolicyProps> = ({ isDesktop }) => {
    return (
        <Box
            paddingX={64}
            className={styles.footerBox}
            paddingTop={isDesktop ? 20 : 24}
            backgroundColor="surface-secondary"
            paddingBottom={isDesktop ? 20 : 32}
        >
            {LINKS.map((link, index) => {
                return (
                    <Text
                        center
                        key={index}
                        type="small-text"
                        mb={isDesktop ? 0 : 24}
                        className={styles.footerLink}
                        color="text-secondary-subdued"
                    >
                        <a target="_blank" rel="noopener noreferrer" href={generatePolicyLink(...link.links)}>
                            <Trans>{link.title}</Trans>
                        </a>
                    </Text>
                );
            })}
            <Text type="small-text" color="text-secondary-subdued" center>
                <a href={'mailto:' + getProjectEmail()}>
                    <Trans>Contact Us</Trans>
                </a>
            </Text>
        </Box>
    );
};

export default FooterWithPolicy;
